<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-two-looking-for-the-hedgehog">
<h1 style="margin-top:250px;font-family:Georgia;">Part Two<br/> Looking for The Hedgehog</h1>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?78ef69a5